import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IProductUnit, IProductUnitDropdown, IProductUnitState } from "../../../types/productUnit/productUnitInterfaces";

export const initialState: IProductUnitState = {
    productUnits: [],
    productUnitsDropdown: [],
    productUnitSelected: null,
};

export const productUnitSlice = createSlice({
    name: "productUnits",
    initialState,
    reducers: {
        /**
         * Cargar todas las unidades de medida.
         */
        loadingProductUnits: (state, action: PayloadAction<IProductUnit[]>) => {
            state.productUnits = action.payload;
        },

        /**
         * Cargar las unidades de medida para el dropdown.
         */
        loadingProductUnitsDropdown: (state, action: PayloadAction<IProductUnitDropdown[]>) => {
            state.productUnitsDropdown = action.payload;
        },

        /**
         * Activar o desactivar una unidad de medida.
         */
        deactivateStateProductUnit: (state, action: PayloadAction<{ id: number; status: boolean }>) => {
            const { id, status: newState } = action.payload;
            state.productUnits = state.productUnits.map((unit) =>
                unit.id === id ? { ...unit, status: newState } : unit
            );
        },

        /**
         * Agregar una nueva unidad de medida al estado global.
         */
        addProductUnit: (state, action: PayloadAction<IProductUnit>) => {
            state.productUnits = [...state.productUnits, action.payload];
        },


        /**
         * Actualizar una unidad de medida.
         */
        updateProductUnit: (state, action: PayloadAction<IProductUnit>) => {
            state.productUnits = state.productUnits.map((unit) =>
                unit.id === action.payload.id ? { ...unit, ...action.payload } : unit
            );
        },
    },
});

export const {
    loadingProductUnits,
    loadingProductUnitsDropdown,
    deactivateStateProductUnit,
    addProductUnit,
    updateProductUnit,
} = productUnitSlice.actions;

export default productUnitSlice.reducer;
